import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import ModuleHeader from "./ModuleHeader";
import ReactEcharts from "echarts-for-react";
import FixedAssetIcon from "@/assets/img/uam/fixed-asset-icon.png";
import MaterialIcon from "@/assets/img/uam/material-icon.png";
import LowValueIcon from "@/assets/img/uam/low-value-icon.png";
import BackgroundCircle from "@/assets/img/uam/background-circle.webp";
import LeftBg from "@/assets/img/uam/left-bg.png";
import RightBg from "@/assets/img/uam/right-bg.png";
import BottomBg from "@/assets/img/uam/bottom-bg.png";
import { uamApi } from "@/api/uamApi";
import { rem2px } from "@/utils/fontSize";
const ProportionAssets = ({ className = "", }) => {
    const chartRef = useRef(null);
    const [dataSource, setDatasource] = useState();
    const getEchartsOption = () => ({
        series: [
            {
                type: "pie",
                radius: ["80%", "90%"], // 缩小环形，匹配设计图的窄环
                center: ["50%", "50%"], // 严格居中
                label: {
                    show: true,
                    position: "center",
                    rich: {
                        title: {
                            fontSize: rem2px(0.14), // 仅ECharts使用rem2px
                            color: "#FFFFFF",
                            lineHeight: rem2px(0.2),
                        },
                        value: {
                            fontSize: rem2px(0.28),
                            color: "#FFFFFF",
                            fontWeight: "bold",
                            lineHeight: rem2px(0.34),
                        },
                    },
                    formatter: `{title|单位总数}\n{value|${dataSource?.total || " "}}`,
                },
                labelLine: { show: false },
                data: [
                    { value: 200, itemStyle: { color: "#4CE092" } }, // 固定资产（绿）
                    { value: 320, itemStyle: { color: "#4C96E0" } }, // 物资（蓝）
                    { value: 400, itemStyle: { color: "#E0964C" } }, // 低值易耗品（橙）
                ],
            },
        ],
    });
    useEffect(() => {
        getData();
    }, []);
    // 仅针对ECharts的响应式监听
    useEffect(() => {
        // 监听根元素fontSize变化
        const rootResizeObserver = new ResizeObserver(() => {
            if (chartRef.current) {
                chartRef.current.getEchartsInstance().setOption(getEchartsOption());
            }
        });
        rootResizeObserver.observe(document.documentElement);
        // 监听窗口resize
        const handleWindowResize = () => {
            if (chartRef.current) {
                chartRef.current.getEchartsInstance().resize();
            }
        };
        window.addEventListener("resize", handleWindowResize);
        return () => {
            rootResizeObserver.disconnect();
            window.removeEventListener("resize", handleWindowResize);
        };
    }, [getEchartsOption]);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await uamApi.assetType();
            if (res.data) {
                setDatasource(res.data);
                // setDatasource({
                //   total: 1004,
                //   eamCount: 854,
                //   uamCount: 0,
                //   lcgCount: 32,
                //   mmsCount: 118,
                // } as any);
            }
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
            // 可以设置默认数据或错误处理
        }
    };
    return (_jsxs("div", { className: `
        relative
        bg-gradient-to-t
        from-[rgba(7,31,75,0.5)]
        to-[rgba(6,32,66,0.5)]
        flex flex-col
        ${className}
        min-h-0
      `, children: [_jsx(ModuleHeader, { title: "\u5229\u65E7\u8D44\u4EA7\u7C7B\u578B\u5360\u6BD4" }), _jsx("div", { className: "flex-1 flex justify-center items-center relative min-h-0", style: { top: "-0.2rem" }, children: _jsx(ReactEcharts, { ref: chartRef, option: getEchartsOption(), style: {
                        width: "1.31rem", // 保持原始rem单位
                        height: "1.31rem",
                        backgroundImage: `url(${BackgroundCircle})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        zIndex: 99,
                    } }) }), _jsxs("div", { className: "absolute left-[0.4rem] top-[0.20rem] flex flex-col justify-center items-center", style: {
                    backgroundImage: `url(${LeftBg})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    width: "1.46rem", // 保持原始rem单位
                    height: "1.20rem",
                }, children: [_jsxs("div", { className: "flex items-center  space-x-[0.1rem]", children: [_jsx("img", { src: FixedAssetIcon, alt: "\u56FA\u5B9A\u8D44\u4EA7", style: {
                                    width: "0.14rem", // 保持原始rem单位
                                    height: "0.14rem",
                                    objectFit: "cover",
                                }, className: "rounded-full" }), _jsx("span", { className: "text-white text-[0.12rem]", children: "\u56FA\u5B9A\u8D44\u4EA7" })] }), _jsx("span", { className: "text-white text-[0.24rem] font-bold", children: dataSource?.eamCount })] }), _jsxs("div", { className: "absolute right-[0.4rem] top-[0.20rem] flex flex-col justify-center items-center", style: {
                    backgroundImage: `url(${RightBg})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    width: "1.46rem", // 保持原始rem单位
                    height: "1.20rem",
                }, children: [_jsxs("div", { className: "flex items-center  space-x-[0.1rem]", children: [_jsx("img", { src: MaterialIcon, alt: "\u7269\u8D44", style: {
                                    width: "0.14rem", // 保持原始rem单位
                                    height: "0.14rem",
                                    objectFit: "cover",
                                }, className: "rounded-full" }), _jsx("span", { className: "text-white text-[0.12rem]", children: "\u7269\u8D44" })] }), _jsx("span", { className: "text-white text-[0.28rem] font-bold", children: dataSource?.mmsCount })] }), _jsxs("div", { className: "absolute -bottom-[0.50rem] left-1/2 transform -translate-x-1/2 flex flex-col justify-center items-center", style: {
                    backgroundImage: `url(${BottomBg})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    width: "1.19rem", // 保持原始rem单位
                    height: "1.54rem",
                }, children: [_jsxs("div", { className: "flex items-center space-x-[0.1rem]", children: [_jsx("img", { src: LowValueIcon, alt: "\u4F4E\u503C\u6613\u8017\u54C1", style: {
                                    width: "0.14rem", // 保持原始rem单位
                                    height: "0.14rem",
                                    objectFit: "cover",
                                }, className: "rounded-full" }), _jsx("span", { className: "text-white text-[0.12rem]", children: "\u4F4E\u503C\u6613\u8017\u54C1" })] }), _jsx("span", { className: "text-white text-[0.24rem] font-bold", children: dataSource?.lcgCount })] })] }));
};
export default ProportionAssets;
